import { useEffect } from "react";

import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";

type SurveyOptions = {
  email?: string;
  name?: string;
  properties?: {
    [key: string]: string;
  };
};

declare global {
  interface Window {
    delighted: { survey: (options: SurveyOptions) => void };
  }
}

export const useDelighted = () => {
  const { data: userData } = useUser();
  const user = userData?.ok ? userData.data : null;
  const { data: orgData } = useOrganization();
  const organization = orgData?.ok ? orgData.data : null;

  useEffect(() => {
    if (!user || !organization || !window.delighted) return;

    const sixtyDaysAgo = new Date();
    sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);

    if (
      (new Date(user.date_joined) < sixtyDaysAgo &&
        !user.is_staff &&
        organization.status === "paying") ||
      window.location.search === "?delighted=test"
    ) {
      window.delighted.survey({
        email: user.email,
        name: user.name,
        properties: {
          created: user.date_joined,
          company: organization.name,
          firstName: user.first_name,
          lastName: user.last_name,
          locale: user.language,
          type: user.user_type,
        },
      });
    }
  }, [user, organization]);
};
